import { render, staticRenderFns } from "./RootCollectionCard.vue?vue&type=template&id=30ea3b92&scoped=true&"
import script from "./RootCollectionCard.vue?vue&type=script&lang=js&"
export * from "./RootCollectionCard.vue?vue&type=script&lang=js&"
import style0 from "./RootCollectionCard.vue?vue&type=style&index=0&id=30ea3b92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea3b92",
  null
  
)

export default component.exports